import * as Yup from 'yup';
import { PropertyUnitIntendedUse, RegistryCategory } from '../../../domain/types';

export default Yup.object({
  sheet: Yup.string().required('Il campo è obbligatorio'),
  parcel: Yup.string().required('Il campo è obbligatorio'),
  category: Yup.string().oneOf(Object.values(RegistryCategory)).required('Il campo è obbligatorio'),
  intendedUse: Yup.string().oneOf(Object.values(PropertyUnitIntendedUse)).required('Il campo è obbligatorio'),
});
